import { useNavigate } from 'react-router-dom'

import NotFoundIcon from '../../assets/not-found.svg'
import { Button, Subtitle, Title, Wrapper } from './style'

const NotFound = () => {
  const navigate = useNavigate()

  return (
    <Wrapper>
      <img src={NotFoundIcon} alt="Not Found" />
      <Title>404</Title>
      <Subtitle>Page Not Found</Subtitle>
      <Button onClick={() => navigate(-1)}>Go to previous page</Button>
    </Wrapper>
  )
}

export default NotFound
